import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import '../styles/LegalPages.css';

const CGV = () => {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>{t('cgv.title')}</h1>
        <p className="legal-updated">{t('cgv.lastUpdated')}</p>

        <section className="legal-section">
          <h2>{t('cgv.objectTitle')}</h2>
          <p>{t('cgv.objectText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('cgv.definitionsTitle')}</h2>
          <ul>
            <li><strong>{t('cgv.platform')}:</strong> {t('cgv.platformDef')}</li>
            <li><strong>{t('cgv.seller')}:</strong> {t('cgv.sellerDef')}</li>
            <li><strong>{t('cgv.buyer')}:</strong> {t('cgv.buyerDef')}</li>
            <li><strong>{t('cgv.product')}:</strong> {t('cgv.productDef')}</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>{t('cgv.registrationTitle')}</h2>
          <p>{t('cgv.registrationText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('cgv.productsTitle')}</h2>
          <p>{t('cgv.productsText')}</p>
          <p>{t('cgv.prohibitedProducts')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('cgv.pricingTitle')}</h2>
          <p>{t('cgv.pricingText')}</p>
          <p>{t('cgv.commissionText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('cgv.paymentTitle')}</h2>
          <p>{t('cgv.paymentText')}</p>
          <p>{t('cgv.escrowText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('cgv.deliveryTitle')}</h2>
          <p>{t('cgv.deliveryText')}</p>
          <p>{t('cgv.deliveryConfirmText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('cgv.returnTitle')}</h2>
          <p>{t('cgv.returnText1')}</p>
          <p>{t('cgv.returnText2')}</p>
          <p>{t('cgv.returnText3')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('cgv.disputeTitle')}</h2>
          <p>{t('cgv.disputeText1')}</p>
          <p>{t('cgv.disputeText2')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('cgv.liabilityTitle')}</h2>
          <p>{t('cgv.liabilityText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('cgv.modificationTitle')}</h2>
          <p>{t('cgv.modificationText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('cgv.lawTitle')}</h2>
          <p>{t('cgv.lawText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('cgv.contactTitle')}</h2>
          <p>{t('cgv.contactText')}</p>
          <p><strong>{t('legal.email')}:</strong> info@main2main.ch</p>
          <p>
            <Link to="/contact" className="legal-link">{t('cgv.contactPage')}</Link>
          </p>
        </section>
      </div>
    </div>
  );
};

export default CGV;
